module.exports = __webpack_public_path__ + "img/cnc-04-compare-01.b85bc194.jpg";